import { __decorate } from "tslib";
import { registerDecorator, ValidatorConstraint, } from 'class-validator';
export function IsFullname(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'IsFullname',
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: IsFullnameConstraint,
        });
    };
}
export function Match(propertyGetter, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [propertyGetter],
            validator: MatchConstraint,
        });
    };
}
let IsFullnameConstraint = class IsFullnameConstraint {
    validate(value) {
        if (!value) {
            return false;
        }
        value = value.trim();
        const regex = /^[a-zA-ZÀ-ÿ]+(([',. -][a-zA-ZÀ-ÿ ])?[a-zA-ZÀ-ÿ]*)*$/;
        if (!regex.test(value)) {
            return false;
        }
        if (value.split(' ').length >= 2) {
            return true;
        }
        return false;
    }
    defaultMessage() {
        return 'Nome inválido. Digite seu nome completo.';
    }
};
IsFullnameConstraint = __decorate([
    ValidatorConstraint({ name: 'IsFullname' })
], IsFullnameConstraint);
export { IsFullnameConstraint };
let MatchConstraint = class MatchConstraint {
    validate(value, args) {
        const [propertyGetter] = args.constraints;
        const relatedValue = propertyGetter(args.object);
        return value === relatedValue;
    }
};
MatchConstraint = __decorate([
    ValidatorConstraint({ name: 'Match' })
], MatchConstraint);
export { MatchConstraint };
let IsStrongPasswordConstraint = class IsStrongPasswordConstraint {
    validate(password) {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
        return regex.test(password);
    }
    defaultMessage() {
        return 'A senha deve conter pelo menos 6 caracteres, uma letra maiúscula, uma letra minúscula e um número.';
    }
};
IsStrongPasswordConstraint = __decorate([
    ValidatorConstraint({ name: 'isStrongPassword', async: false })
], IsStrongPasswordConstraint);
export function IsStrongPassword() {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isStrongPassword',
            target: object.constructor,
            propertyName: propertyName,
            options: {},
            validator: IsStrongPasswordConstraint,
        });
    };
}
